import { BaseRouteService } from 'core/services';

class LinksRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'links/';
	}

	findLinks(filter) {
		return super.create(this.base + 'find-links', filter);
	}
}

export default LinksRouteService;
